var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditTrail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 310,
    r: 100
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.213 460.786-82.586-82.586c-10.653 17.217-25.209 31.773-42.426 42.427l82.586 82.586c11.716 11.716 30.711 11.716 42.426 0 11.716-11.716 11.716-30.711 0-42.427z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m100 8.787-91.213 91.213h91.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90 260h100.006c8.168-19.53 20.968-36.657 37.022-50h-137.028z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.539 290h-106.539c-8.284 0-15-6.716-15-15v-80c0-8.284 6.716-15 15-15h235c30.146 0 57.925 10.316 80 27.6v-162.6c0-24.813-20.187-45-45-45h-215v115c0 8.284-6.716 15-15 15h-115v337c0 24.813 20.187 45 45 45h300c22.342 0 40.924-16.369 44.406-37.741l-40.281-40.281c-12.354 3.907-25.496 6.022-39.125 6.022-31.515 0-60.444-11.276-82.972-30h-152.028c-8.284 0-15-6.716-15-15s6.716-15 15-15h125.498c-5.944-9.266-10.736-19.335-14.193-30h-111.305c-8.284 0-15-6.716-15-15s6.716-15 15-15h105.381c-1.369-14.973 1.158-30 1.158-30zm133.461-140h-140c-8.284 0-15-6.716-15-15s6.716-15 15-15h140c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-60h-140c-8.284 0-15-6.716-15-15s6.716-15 15-15h140c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditTrail);
export default __webpack_public_path__ + "static/media/audit-trail.f3f10e5f2201203d4e9ad2646983ed7e.svg";
export { ForwardRef as ReactComponent };